module.exports = __webpack_public_path__ + "static/glitch-31b83730639cfcb8c77abb77e9f50cd8.png";